import { render, staticRenderFns } from "./ReleaseVersion.vue?vue&type=template&id=54530e6a&scoped=true"
import script from "./ReleaseVersion.vue?vue&type=script&lang=js"
export * from "./ReleaseVersion.vue?vue&type=script&lang=js"
import style0 from "./ReleaseVersion.vue?vue&type=style&index=0&id=54530e6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54530e6a",
  null
  
)

export default component.exports